import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-subcategories',
  imports: [RouterModule],
  templateUrl: './admin-subcategories.html',
  styleUrl: './admin-subcategories.scss',
})
export class AdminSubcategories {}
